import GoldLiquidHero from '@/components/special-effects/gold-liquid';

export default function HeroSection() {
  return <GoldLiquidHero />;
}